import {useQuery} from "@tanstack/react-query";
import axios from "axios";
import {ResponseList} from "../../../models/common/Response";
import {ConfigLog} from "../../../models/config/ConfigLog";

export function useConfigLog() {
    return useQuery({
        queryKey: ['config-log'],
        queryFn: ({ signal }) => {
            const accessToken = localStorage.getItem('LG_APPLICATION');
            return axios.get<ResponseList<ConfigLog>>(
                '/v1/configuration/log',
                {
                    signal,
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    },
                }
            );
        },
        select: (response: { data: ResponseList<ConfigLog> }) => response.data.result_list as ConfigLog[],
        retry: 1,
    });
}